import TextForm from "../components/TextForm.tsx";
import {useContext, useState} from "react";
import {useTranslation} from "react-i18next";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";
import AuthContext from "../contexts/AuthContext.tsx";
import {Container, Paper} from "@mui/material";
import {IOrder} from "../models/IOrder.ts";
import OrderContext from "../contexts/OrderContext.tsx";

const defaultOrder: IOrder = {
    items: [],
    shippingAddress: {
        name: '',
        street: '',
        address2: '',
        city: '',
        region: '',
        postalCode: '',
        country: '',
        email: '',
    },
    paymentMethod: 'Kreditkarte',
    totalPrice: 0,
    shippingCost: 0,
}

const LoginPage = () => {
    const {t} = useTranslation()
    const navigate = useNavigate();
    const formLabels = [`${t('EMAIL_TEXT')}`, `${t('PASSWORD_TEXT')}`]
    const [formData, setFormData] = useState<any>({
        email: {value: '', required: true},
        password: {value: '', required: true},
    })
    const {loginMutation, loginError, setLoginError} = useContext(AuthContext)
    const {setOrder} = useContext(OrderContext)
    const [loading, setLoading] = useState<boolean>(false);


    const handleLogin = () => {
        setLoading(true);
        setLoginError(null);
        loginMutation.mutate(
            {
                email: formData.email.value,
                password: formData.password.value,
            },
            {
                onSuccess: () => {
                    setLoading(false)
                },
                onError: () => {
                    setLoading(false)
                }
            }
        )
        if (!loginError) {
            setOrder(defaultOrder)
            sessionStorage.clear()
        }
    }

    const handleChange = (key: string, value: string) => {
        const updatedValue = formData[key]
        updatedValue.value = value
        setFormData((prevValue: any) => ({
            ...prevValue,
            [key]: updatedValue
        }))
    }

    const clickRegister = () => {
        navigate("/register")
    }

    return (
        <Container sx={{padding: '12px'}}>
            <Paper elevation={4}
                   sx={{
                       display: 'flex',
                       flexDirection: 'column',
                       maxWidth: '900px',
                       alignItems: 'center',
                       margin: 'auto',
                       padding: '12px',
                   }}
            >
                <TextForm
                    formLabels={formLabels}
                    formData={formData}
                    onChange={handleChange}
                    submitText={`${t('LOGIN_TEXT')}`}
                    loading={loading}
                    onSubmit={() => {
                        handleLogin()
                    }}
                    formHeader={`${t('LOGIN_TEXT')}`}
                >
                    {loginError ? (
                        <Typography
                            sx={{color: 'red'}} variant="body1"
                        >
                            {loginError}
                        </Typography>
                    ) : null}
                    <Typography
                        onClick={clickRegister}
                        sx={{textAlign: 'left', width: '95%', cursor: 'pointer'}} variant="body1"
                    >
                        {t("NO_ACCOUNT_TEXT")}
                    </Typography>
                </TextForm>
            </Paper>
        </Container>
    )
}

export default LoginPage